import { GoogleCloudStorageLocationAdapter } from 'app/model/adapters/datasets/location/google-cloud-storage.location.adapter';
import { AdapterRegistry, IModel, Metamodel, SapDatasphereForGoogleCloudStorageLocation } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForGoogleCloudStorageLocation)
})
export class SapDatasphereForGoogleCloudStorageLocationAdapter extends GoogleCloudStorageLocationAdapter {
    protected model(): IModel {
        return SapDatasphereForGoogleCloudStorageLocation.MODEL;
    }
}
